import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { MoreCaseStudies } from '../../../../components'

import { meta } from '../../index.js'

export default class bau extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'Bitcoin Australia')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study"> 

				    <div className="container">

				        <div className="title">

				            <a href="https://bitcoin.com.au" target="_blank"><img src="/images/new/logos/bau.svg"/></a>
				            <h3>The future of finance, today</h3>

				            <p>Bitcoin has revolutionised the way we think about money, exploding onto the financial scene in 2009 as the world’s first decentralised digital currency. Offering a host of advantages over traditional currencies, bitcoin Australia provides greater privacy and security, as well as faster transaction speed. Despite being one of the largest bitcoin exchange facilitators in the country, Bitcoin Australia were lacking physical deposit facilities for their customers. </p>

				        </div>

						<div className="block">
						
								<h4>Diagnosing problems</h4>
				                <p>Until now, purchasing cryptocurrency quickly had been a real pain point. Settlement times of existing payment gateways meant that people were often out of pocket for days after a purchase.</p>

						</div>

				        <div className="block">

				                <h4>Updating the current system</h4>
				                <p>Seeing the need for improvement, blueshyft leveraged it’s national network to build an instant payment gateway for Bitcoin.com.au customers. Key upgrades included:</p>

				            <div className="features">

				                <div className="feature">
				                    <img src="/images/new/icons/cash-blue.svg"/>
				                    <p>World-first, instant payments</p>
				                </div>
				                <div className="feature">
				                        <img src="/images/new/icons/cross-blue.svg"/>
				                        <p>Irreversible, fraud-proof purchases</p>
				                    </div>
				                <div className="feature">
				                    <img src="/images/new/icons/map-blue.svg"/>
				                    <p>1,500+ convenient retailer locations </p>
				                </div>

				            </div>
				    
				        </div>

				        <div className="block">

				            <h4>Update successfully installed</h4>
				            <p>At lightning speed, blueshyft integrated with Bitcoin Australia’s systems to develop a unique solution for their customers. Key upgrades included: </p>
				            <p>•  Instant payments - using the blueshyft platform, any customer with a Bitcoin Australia account can make instant payments in-store</p>
				            <p>•  A national retail network - with over 1,500+ shop fronts across the country, Bitcoin Australia’s customers are never far from a secure deposit location</p>
				            <p>•  Irreversible, fraud-proof purchases - blueshyft provides secure face-to-face transactions free of charge backs</p>

				        </div>

				        <div className="highlight">

				            <p>With their new offering, both Bitcoin Australia’s deposits and repeat customers are on the rise. Since their launch in May 2016, Bitcoin Australia has seen a sharp increase in deposits and user engagement. With dramatic improvements in customer convenience and transaction speed, the partnership has helped thousands of everyday Australians enter the cryptocurrency ecosystem secure and hassle-free.</p>
				    
				        </div>

				    </div>


				</section>

				<MoreCaseStudies cases={['goget', 'news', 'lb']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/bau/index.js